import * as React from 'react'
import { Modal, Button, Icon, Row, Col, Input } from 'antd'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import { ComponentExt } from 'util/reactExt'
import styles from './index.scss'
import Validator from 'util/validator'
import { generateRandomNumber } from 'util/utils'

const confirm = Modal.confirm

interface ICheckGroupModalProps {
  levelStore?: any
}

interface ICheckGroupModalState {
  activeGroupID: number
}

@inject('globalStore', 'levelStore')
@observer
export default class ConfigContentModal extends ComponentExt<
  ICheckGroupModalProps,
  ICheckGroupModalState
> {
  state = {
    activeGroupID: 0,
  }

  addGroup = () => {
    const {
      levelStore: { addCheckGroup },
    } = this.props
    const groupID = generateRandomNumber(8)
    const checkGroup = {
      id: groupID,
      name: '',
    }
    addCheckGroup(checkGroup)
    this.activeGroup(groupID)
  }

  activeGroup = id => {
    this.setState({
      activeGroupID: id,
    })
  }

  updateGroup = (group, evt) => {
    const {
      levelStore: { updateGroup },
    } = this.props
    updateGroup({ id: group.id, name: evt.target.value })
  }

  deleteGroup = index => {
    confirm({
      title: '删除分组',
      content: '请注意该操作将会重置属于当前分组的关卡',
      onOk: () => {
        const {
          levelStore: { deleteGroup },
        } = this.props
        deleteGroup(index)
      },
    })
  }

  isInvalidField = () => {
    const {
      levelStore: {
        checkTemplate: { check_groups },
      },
    } = this.props
    const validator = new Validator()

    if (!check_groups) {
      return false
    }
    for (const [index, group] of Object.entries(toJS(check_groups))) {
      const errMsgMap = {
        name: num => `第 ${num} 个分组名称不能为空`,
      }
      const target = Number(index) + 1
      validator.add((group as any).name.trim(), [
        {
          strategy: 'isNonEmpty',
          errMsg: errMsgMap.name(target),
        },
      ])
    }

    const errors: any = validator.start(true)

    if (errors.length > 0) {
      this.$message.error(
        <div>
          {errors.map((err, index) => (
            <p key={index}>{err}</p>
          ))}
        </div>,
      )
      return true
    }
    return false
  }

  onSubmit = async (): Promise<any> => {
    const {
      levelStore: { toggleGroupModal },
    } = this.props

    const isInvalidField = this.isInvalidField()
    if (isInvalidField) {
      return
    }
    toggleGroupModal()
  }

  onCancel = () => {
    const isInvalidField = this.isInvalidField()

    if (isInvalidField) {
      return
    }
    this.props.levelStore.toggleGroupModal()
  }

  render() {
    const {
      levelStore: {
        groupModalVisible,
        toggleGroupModal,
        checkTemplate: { check_groups },
      },
    } = this.props
    const { activeGroupID } = this.state
    return (
      <Modal
        width={800}
        title="分组设置"
        visible={groupModalVisible}
        onOk={this.onSubmit}
        onCancel={this.onCancel}
        className={styles.groupModal}
      >
        <section className={'styles.groupAddition'}>
          <Button onClick={this.addGroup}>
            <Icon type="plus" />
          </Button>
        </section>
        <section className={styles.groupOperation}>
          {check_groups &&
            check_groups.map((group, index) => {
              const isCurrentGroup = activeGroupID === group.id
              return (
                <Row
                  className={styles.groupOperationItem}
                  key={group.id}
                  type="flex"
                  align="middle"
                >
                  <Col span={3}>
                    <span>分组名称：</span>
                  </Col>
                  <Col span={12}>
                    <Input
                      placeholder="请输入分组名称"
                      value={group.name}
                      onChange={this.updateGroup.bind(this, group)}
                      disabled={isCurrentGroup ? false : true}
                    />
                  </Col>
                  <Col span={3} offset={1}>
                    <Button
                      onClick={this.activeGroup.bind(
                        this,
                        isCurrentGroup ? -1 : group.id,
                      )}
                    >
                      {isCurrentGroup ? '确定' : '编辑'}
                    </Button>
                  </Col>
                  <Col span={3}>
                    <Button onClick={this.deleteGroup.bind(this, group.id)}>
                      删除
                    </Button>
                  </Col>
                </Row>
              )
            })}
        </section>
      </Modal>
    )
  }
}
